import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";

const breadcrumbStatic = [{
	name: 'Managers',
	url: '/managers',
	icon: 'dashboard'
}];

export default class Managers extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history} = this.props;
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}>
					<Button  style={{float: "right"}} data-id="add-user" onClick={this.toggle('modalAlertAdd')} size="sm" color="primary">
						<i className="fa fa-edit"/>&nbsp;&nbsp;Add Alert
					</Button>
					</Framework.Components.PageBar>
				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Alert"}
					object={Objects.Alert}
					history={this.props.history}
					toggle={this.state.modalAlertAdd}
					reportClose={this.reportClose('modalAlertAdd')}
					afterSave={() => this.setState({refresh: !this.state.refresh})}
					objectProps={{ roles: this.props.roles}}
				/>

				<div className={"row"}>
					<div className={"col"}>
						<Collections.Alerts history={history} />
					</div>
				</div>
			</div>
		)
	}
}